<div class="mapfre-hide-mobile mapfre-hide-tablet footer-container">
  <div class="footer" responsive-breakpoints>

    <div class="flex jc-sb ">
      <div class="dark-blue">
        MAPFRE © {{year}} Todos los derechos reservados
        <div class=" w-60 flex f-wrap m-0 ">

          <div *ngFor="let item of footerData.legals" class="dark-blue item my-1 cp border-r "
            (click)="navTo(item.id) ">
            {{ item?.label | translate }}
          </div>
          <div class="ot-sdk-show-settings"
            style="text-decoration: none; border: 0px !important; background: none; opacity: 1; cursor: pointer; color: #526570; margin: 0.5rem 0rem">
            Configuración de las cookies
          </div>
        </div>
      </div>

      <div class="social-media-icons w-50">
        <img class="mapfre-ml-m cp " (click)="navToSocialMedia(i)" *ngFor="let ele of socialMediaLinks;let i = index"
          [src]="imgPath + ele + '.svg'" alt=" " />

      </div>
    </div>
  </div>
</div>

<div class="responsive-links mapfre-mt-m mapfre-hide-desktop">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="dark-blue mapfre-fs-s fw-500">Legal</mat-expansion-panel-header>
      <div *ngFor="let item of footerData.legals" (click)="navTo(item.id)" class="dark-blue mapfre-fs-s mapfre-mt-xsm">
        {{ item?.label | translate }}
      </div>
      <div class="ot-sdk-show-settings"
        style="text-decoration: none; border: 0px !important; background: none; opacity: 1; cursor: pointer; color: #526570; margin: 0.5rem 0rem">
        Configuración de las cookies
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="flex fd-col ai-c mapfre-mt-m ">
    <div class="social-media-icons">
      <img class="mapfre-ml-xs" (click)="navToSocialMedia(i)" *ngFor="let ele of socialMediaLinks;let i = index"
        [src]="imgPath + ele + '.svg'" alt=" " />
    </div>
    <div class="dark-blue text-center mapfre-mt-sm">
      MAPFRE © {{year}}
      <div>{{ 'FOOTER.ALL_RIGHTS' | translate}}</div>
    </div>

  </div>
</div>